window.addEventListener("resize", function () {
	resizer()
}, true);
init();
if (!halteverything) {
	animate()
}
function init() {
	if (Detector.webgl) {
		renderer = new THREE.WebGLRenderer({
			antialias: true
		});
		logoren = new THREE.WebGLRenderer({
			antialias: true,
			alpha: true
		})
	} else if (Detector.canvas) {
			renderer = new THREE.CanvasRenderer();
			logoren = new THREE.CanvasRenderer()
		} else {
			halteverything = true;
			return
	}
	loader.texturePath = textures;
	logocam = new THREE.PerspectiveCamera(20, 1, 1, 10000);
	logoscn = new THREE.Scene();
	logoelemen.style.width = window.innerWidth / 100 * lsize + "px";
	logoelemen.style.height = window.innerWidth / 100 * lsize + "px";
	var callbackLogo = function (geometry, materials) {
		logo = createScene("Logo", geometry, materials, false, 0, 0, -20, 0.1, shd);
		logoscn.add(logo);
		logoscn.add(logocam);
		collidersLogo2.push(logo);
		logotw = new TWEEN.Tween(logo.rotation)
.to({y: 3.1415926535897932384626433832795}, 1000)
.onUpdate(function () {logo.rotation.y = this.y})
.repeat(Infinity)
.start()
	};
	menush = true;
	loader.load(logom, callbackLogo);
	var lightLogo = new THREE.DirectionalLight(0xffffff);
	lightLogo.position.set(0, 0, 1).normalize();
	logoscn.add(lightLogo);
	var conta = document.createElement("div");
	conta.id = "3dgalerija";
	conta.style.width = "100%";
	conta.style.height = "100%";
	document.body.style.overflow = "hidden";
	document.body.style.margin = "0px";
	document.body.style.backgroundColor = "#f0f0f0";
	conta.style.backgroundColor = "#f0f0f0";
	container = document.body.appendChild(conta);
	var r = textures + "cube/";
	ray1 = new THREE.Raycaster();
	raylogo = new THREE.Raycaster();
	SCREEN_WIDTH = window.innerWidth;
	SCREEN_HEIGHT = window.innerHeight;
	var urls = [r + "logo512cub.jpg", r + "logo512cub.jpg", r + "logo512cub.jpg", r + "logo512cub.jpg", r + "logo512cub.jpg", r + "logo512cub.jpg"];
	totob = polica.length;
	camera1 = new THREE.PerspectiveCamera(30, SCREEN_WIDTH / SCREEN_HEIGHT, 1, 10000);
	camera1.name = "kamera 1";
	scene = new THREE.Scene();
	scene.add(camera1);
	var amb1 = new THREE.AmbientLight(0x404040);
	amb1.name = "Ambijent";
	logoren.setSize(window.innerWidth / 100 * lsize, window.innerWidth / 100 * lsize);
	logoelemen.appendChild(logoren.domElement);
	logoren.domElement.id = "logo";
	renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT);
	renderer.gammaInput = false;
	renderer.gammaOutput = false;
	renderer.shadowMap.enabled = shadow;
	renderer.setClearColor(0xf0f0f0);
	container.appendChild(renderer.domElement);
	var texcubeloader = new THREE.CubeTextureLoader();
	var txcbcb = function (textures) {
		textureCube = textures;
		textureCube.format = THREE.RGBFormat;
		textureCube.reflectivity = 1.0;
		scene.add(amb1);
		for (var ldp = 0; ldp < totob; ldp++) {
			partload(polica[ldp], policaFile[ldp], ldp)
		}
		textotal++;
		var axisHelper = new THREE.AxesHelper(100);
		lightsMake(scene, true)
	};
	texcubeloader.load(urls, txcbcb)
}

function animate(time) {
	requestAnimationFrame(animate);
	TWEEN.update(time);
	render();
	update()
}

function render() {
	if (compositeObject.length) {
//		if (ready == readytot) {
			if (!idle || aidle || firstframe) {
//				if (THREE.TextureIdCount == textotal) {
					renderer.render(scene, camera1);
					idle = true;
					if (firstframe) {
						firstframe--
					}
//				}
			}
			if (logo) {
				logoren.render(logoscn, logocam)
			}
			if (doonce) {
				for (var t = 0; t < totob; t++) {materialManager(compositeObject[t], t)};
				logopos();
				logoelemen.addEventListener("mousedown", buttondown, false);
				if (doClones) {
					for (var t = 0; t < totclones.length; t = t + 2) {
						for (var t2 = 0; t2 < totclones[t].length; t2++) {
							totclones[t][t2].traverse(function (node) {
								if (node.userData) {
									if (node.userData.movingPropertiesData) {
										if (node.userData.movingPropertiesData.condition) {
											var cond = node.userData.movingPropertiesData.condition;
											if (cond.object.cloneNext != undefined) {
												var cloneNext = cond.object.cloneNext;
												var clonePrev = cond.object.clonePrev;
												cond.object = [];
												cond.state = [];
												if (totclones[t][t2 - 1]) {
													cond.object[0] = totclones[t][t2 - 1];
													cond.state[0] = clonePrev
												}
												if (totclones[t][t2 + 1]) {
													cond.object[1] = totclones[t][t2 + 1];
													cond.state[1] = cloneNext
												}
											}
										}
									}
								}
							})
						}
					}
				}
				for (var t = 0; t < totob; t++) {
					collidersStatic.push(compositeObject[t]);
					compositeObject[t].box = new THREE.Box3().setFromObject(compositeObject[t]);
					compositeObject[t].traverse(function (node) {
						if (node.userData.mobile) {
							collidersMoving.push(node)
						}
					})
				}
				findPos(renderer.domElement);
				doonce = false;
				for (var index in prt) {
					prt[index] = null
				}
				prt = null
			}
//		}
	}
}

function update() {
	var delta = clock.getDelta();
	if (objtrig == true) {
		if (triggered.userData.state == undefined) {
			if (triggered.parent.userData.state != undefined) {
				triggered = triggered.parent
			} else {
				if (triggered.parent.parent.userData.state != undefined) {
					triggered = triggered.parent.parent
				}
			}
		}
		objtrig = false;
		objs = [];
		if (triggered.userData.tandems) {
			if (!triggered.userData.movingPropertiesData.tandemMain) {
				for (var tt = 0; tt < triggered.userData.tandems.length; tt++) {
					if (triggered.userData.tandems[tt].userData.movingPropertiesData.tandemMain) {
						objs[0] = triggered.userData.tandems[tt];
						break
					}
				}
			} else {
				objs[0] = triggered
			}
			for (var tt = 0; tt < objs[0].userData.tandems.length; tt++) {
				objs.push(objs[0].userData.tandems[tt])
			}
		} else {
			objs[0] = triggered
		}
		var mobjMoving = [];
		var onUpdateText = "onUpdate = function() {";
		var onCompleteText = "onComplete = function() {";
		var ftext2 = "}";
		var mobjMovingAxsis = [];
		var mobjStartValue = [];
		var mobjEndValue = [];
		var movingAcr = [];
		var mobjIindex = [];
		var mobjTweenmov = {};
		var mobjTweasing = [];
		var mobjObarrtem = [];
		var mobjTweentarget = {};
		var goon = true;
		if (objs[0].userData.movingPropertiesData.condition) {
			var obj = objs[0].userData.movingPropertiesData.condition.object;
			var state = objs[0].userData.movingPropertiesData.condition.state;
			for (var t = 0; t < obj.length; t++) {
				if (obj[t] !== undefined && obj[t].userData.state !== state[t]) {
					goon = false;
					break
				}
			}
		}
		if (goon) {
			movrunning = true;
			for (var mpl = 0; mpl < objs.length; mpl++) {
				mpll = mpl;
				mobjTweenmov[mpll] = {};
				mobjTweentarget[mpll] = {};
				for (var asr = 0; asr < compositeObject.length; asr++) {
					compositeObject[asr].traverse(function (node) {
						if (node.name == objs[mpll].name) {
							mobjObarrtem[mpll] = node;
							return;
						}
					});
					if (mobjObarrtem[mpll]) {
						break
					}
				}
				movingAcr[mpll] = objs[mpll].userData.movingProperties.substr(0, 3);
				objs[mpll].userData.trigger = false;
				switch (movingAcr[mpll]) {
				case "loc":
					mobjMoving[mpll] = "position";
					break;
				case "rot":
					mobjMoving[mpll] = "rotation";
					break;
				case "siz":
					mobjMoving[mpll] = "scale";
					break
				}
				mobjMovingAxsis[mpll] = objs[mpll].userData.movingProperties.substr(4, 1);
				mobjStartValue[mpll] = objs[mpll][mobjMoving[mpll]][mobjMovingAxsis[mpll]];
				if (objs[mpll].userData.direction) {
					mobjEndValue[mpll] = objs[mpll][mobjMoving[mpll]][mobjMovingAxsis[mpll]] - objs[mpll].userData.movingPropertiesData[movingAcr[mpll]][mobjMovingAxsis[mpll]];
					objs[mpll].userData.direction = false
				} else {
					objs[mpll].userData.direction = true;
					mobjEndValue[mpll] = objs[mpll][mobjMoving[mpll]][mobjMovingAxsis[mpll]] + objs[mpll].userData.movingPropertiesData[movingAcr[mpll]][mobjMovingAxsis[mpll]]
				}
				mobjTweenmov[mpll] = mobjStartValue[mpll];
				mobjTweasing[mpll] = objs[mpll].userData.movingPropertiesData.tweenmethod;
				mobjTweentarget[mpll] = mobjEndValue[mpll];
				if (objs[mpll].userData.sound) {
					var sound1 = new Sound([objs[mpll].userData.sound[0], objs[mpll].userData.sound[1]], 275, 1);
					sound1.position.copy(objs[mpll].position);
					sound1.play()
				}
				if (objs[mpll].userData.state) {
					obstate = false
				} else {
					obstate = true
				}
				onUpdateText = onUpdateText + "objs[" + mpll + "]." + mobjMoving[mpll] + "." + mobjMovingAxsis[mpll] + " = this[" + mpll + "];mobjObarrtem[" + mpll + "]." + mobjMoving[mpll] + "." + mobjMovingAxsis[mpll] + " = this[" + mpll + "];objs[" + mpll + "].matrixWorldNeedsUpdate = true;mobjObarrtem[" + mpll + "].matrixWorldNeedsUpdate = true;";
				onCompleteText = onCompleteText + "objs[" + mpll + "].userData.running = false;objs[" + mpll + "].userData.state = " + obstate + ";"
			}
			onUpdateText = onUpdateText + ftext2;
			onCompleteText = onCompleteText + "triggered=false;movrunning=false;aidle--;firstframe++;" + ftext2;
			var onUpdate = eval(onUpdateText);
			var onComplete = eval(onCompleteText);
			var movobtw = new TWEEN.Tween(mobjTweenmov)
.to(mobjTweentarget, objs[0].userData.movingPropertiesData.duration)
.onUpdate(onUpdate)
.easing(mobjTweasing[0])
.delay(objs[0].userData.movingPropertiesData.delay)
.onComplete(onComplete)
.onStart(function () {
				aidle++
			})
.start()
		}
	}
}

function createScene(name, geometry, materials, materials2, x, y, z, s, sh, ts, sc, sc2, second, cm, col) {
	var zmesh, zmesh2;
	if (materials == 0) {
		if (cm) {
			zmesh = new THREE.Mesh(geometry, cm);
			if (second == 1) {
				zmesh2 = new THREE.Mesh(geometry, cm)
			}
			if (second == 2) {
				zmesh = new THREE.Mesh(geometry, cm)
			}
		} else {
			zmesh = new THREE.Mesh(geometry);
			if (second == 1) {
				zmesh2 = new THREE.Mesh(geometry)
			}
			if (second == 2) {
				zmesh = new THREE.Mesh(geometry)
			}
		}
	};
	if (cm) {
		if (materials[0]) {
			for (var t = 0; t < materials.length; t++) {
				materials[t].envMap = cm;
				//materials[t].metal = true;
				if (materials2) {
					materials2[t].envMap = cm;
					//materials2[t].metal = true
				}
			}
		} else {
			materials.envMap = cm;
			//materials.metal = true;
			if (materials2) {
				materials2.envMap = cm;
				//materials2.metal = true
			}
		}
	};
	zmesh = new THREE.Mesh(geometry, materials);
	if (materials2) {
		zmesh2 = new THREE.Mesh(geometry, materials2)
	};
	zmesh.position.set(x, y, z);
	zmesh.scale.set(s, s, s);
	zmesh.name = name;
	if (materials2) {
		zmesh2.position.set(x, y, z);
		zmesh2.scale.set(s, s, s);
		zmesh2.name = name
	};
	switch (sh) {
	case 1:
		zmesh.receiveShadow = true;
		if (materials2) {
			zmesh2.receiveShadow = true
		}
		break;
	case 2:
		zmesh.castShadow = true;
		zmesh.receiveShadow = true;
		if (materials2) {
			zmesh2.castShadow = true;
			zmesh2.receiveShadow = true
		}
		break;
	default:
		break
	}
	if (ts) {
		sc.add(zmesh);
		if (materials2) {
			sc2.add(zmesh2)
		}
		if (col) {
			collidersMoving.push(zmesh)
		}
	} else {
		if (materials2) {
			return [zmesh, zmesh2]
		} else {
			return zmesh
		}
	}
}

function slagalica(part, no, parent, child, extra, clone) {
	if (extra !== undefined) {
		var extr = extra
	} else {
		var extr = 0
	};
	for (var ext = 0; ext < part.parts.broj; ext++) {
		if (part.parts[ext].childTo) {
			for (var parentseg = 0; parentseg < part.parts[part.parts[ext].childTo].brojseg; parentseg++) {
				for (var parentbps = 0; parentbps < part.parts[part.parts[ext].childTo].brojposeg; parentbps++) {
					var parenttmpname = parent.name + " " + part.parts[part.parts[ext].childTo].name + " " + parentseg + " " + parentbps;
					for (var seg = 0; seg < part.parts[ext].brojseg; seg++) {
						for (var bps = 0; bps < part.parts[ext].brojposeg; bps++) {
							if (part.parts[ext].id===7&&bps===0){
								part.parts[ext].id=7
							}
							if (!part.parts[ext][bps]) {
								part.parts[ext][bps] = {}
							}
							if (part.parts[ext][bps].loc) {
								var loc = part.parts[ext][bps].loc
							} else {
								var loc = {};
								loc.x = 0;
								loc.y = 0;
								loc.z = 0
							}
							if (part.parts[ext][bps].rot) {
								var rot = part.parts[ext][bps].rot
							} else {
								var rot = {};
								rot.x = 0;
								rot.y = 0;
								rot.z = 0
							}
							if (part.parts[ext][bps].step) {
								var step = part.parts[ext][bps].step
							} else {
								var step = {};
								step.x = 0;
								step.y = 0;
								step.z = 0
							}
							if (clone!==undefined) {
								loc.x = loc.x - clone.x;
								loc.y = loc.y - clone.y;
								loc.z = loc.z - clone.z
							}
							var namech = part.parts[ext].name + " " + seg + " " + bps;
							if (part.parts[ext].env == true) {
								var env = textureCube
							} else {
								var env = false
							}
							if (part.parts[ext].name=="Cylinder395"){
								part.parts[ext].name="Cylinder395"
//								console.log ("bps="+bps+"\nseg="+seg)
							}
							parent.traverse(function (node) {
								if (node.name == parenttmpname) {
									partplace(child[ext + extr], loc, rot, node, step, seg, env, namech, part, ext);
									return
								}
							})
						}
					}
				}
			}
		} else {
			for (var seg = 0; seg < part.parts[ext].brojseg; seg++) {
				for (var bps = 0; bps < part.parts[ext].brojposeg; bps++) {
					if (!part.parts[ext][bps]) {
						part.parts[ext][bps] = {}
					};
					if (part.parts[ext][bps].loc) {
						var loc = part.parts[ext][bps].loc
					} else {
						var loc = {};
						loc.x = 0;
						loc.y = 0;
						loc.z = 0
					}
					if (part.parts[ext][bps].rot) {
						var rot = part.parts[ext][bps].rot
					} else {
						var rot = {};
						rot.x = 0;
						rot.y = 0;
						rot.z = 0
					}
					if (part.parts[ext][bps].step) {
						var step = part.parts[ext][bps].step
					} else {
						var step = {};
						step.x = 0;
						step.y = 0;
						step.z = 0
					}
					if (clone!==undefined) {
						loc.x = loc.x - clone.x;
						loc.y = loc.y - clone.y;
						loc.z = loc.z - clone.z
					}
					var namech = part.parts[ext].name + " " + seg + " " + bps;
					if (part.parts[ext].env == true) {
						var env = textureCube
					} else {
						var env = false
					}
					partplace(child[ext + extr], loc, rot, parent, step, seg, env, namech, part, ext)
				}
			}
		}
	}
	if (part.parts.mobile == true) {
		for (var ttmob = 0; ttmob < part.parts.mobileparam.movingParts.length; ttmob++) {
			if (part.parts.mobileparam.movingParts[ttmob] < 0) {
				parent.userData.trigger = false;
				parent.userData.running = false;
				parent.userData.direction = false;
				parent.userData.movingProperties = part.parts.mobileparam.movingProperties[ttmob];
				parent.userData.movingPropertiesData = part.parts.mobileparam.movingPropertiesData[ttmob];
				parent.userData.isDifferential = part.parts.mobileparam.isDifferential[ttmob];
				parent.userData.startcondition = part.parts.mobileparam.startcondition[ttmob];
				parent.userData.state = part.parts.mobileparam.movingPropertiesData[ttmob].defaultState;
				if (part.parts.mobileparam.movingPropertiesData[ttmob].tweenmethod == "TWEEN.Easing.Sinusoidal.InOut") {
					parent.userData.movingPropertiesData.tweenmethod = TWEEN.Easing.Sinusoidal.InOut
				}
				movobj.push(parent)
			} else {
				for (var t = 0; t < part.parts[part.parts.mobileparam.movingParts[ttmob]].brojseg; t++) {
					for (var t1 = 0; t1 < part.parts[part.parts.mobileparam.movingParts[ttmob]].brojposeg; t1++) {
						for (var nsearch = 0; nsearch < parent.children.length; nsearch++) {
							if (parent.children[nsearch].name == parent.name + " " + part.parts[part.parts.mobileparam.movingParts[ttmob]].name + " " + t + " " + t1) {
								movobj.push(parent.children[nsearch]);
								var obcolindex = movobj.length - 1;
								movobj[obcolindex].userData.trigger = false;
								movobj[obcolindex].userData.running = false;
								movobj[obcolindex].userData.direction = false;
								movobj[obcolindex].userData.movingProperties = part.parts.mobileparam.movingProperties[ttmob];
								movobj[obcolindex].userData.movingPropertiesData = {};
								movobj[obcolindex].userData.movingPropertiesData.delay = part.parts.mobileparam.movingPropertiesData[ttmob].delay;
								movobj[obcolindex].userData.movingPropertiesData.duration = part.parts.mobileparam.movingPropertiesData[ttmob].duration;
								movobj[obcolindex].userData.movingPropertiesData.defaultState = part.parts.mobileparam.movingPropertiesData[ttmob].defaultState;
								movobj[obcolindex].userData.movingPropertiesData.loc = part.parts.mobileparam.movingPropertiesData[ttmob].loc;
								movobj[obcolindex].userData.movingPropertiesData.rot = part.parts.mobileparam.movingPropertiesData[ttmob].rot;
								movobj[obcolindex].userData.movingPropertiesData.siz = part.parts.mobileparam.movingPropertiesData[ttmob].siz;
								if (part.parts.mobileparam.movingPropertiesData[ttmob].condition) {
									movobj[obcolindex].userData.movingPropertiesData.condition = {};
									if (part.parts.mobileparam.movingPropertiesData[ttmob].condition.object[0]) {
										movobj[obcolindex].userData.movingPropertiesData.condition.object = [];
										movobj[obcolindex].userData.movingPropertiesData.condition.state = [];
										for (var xxx = 0; xxx < part.parts.mobileparam.movingPropertiesData[ttmob].condition.object.length; xxx++) {
											if (part.parts[ttmob].brojposeg != part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].condition.object[xxx]].brojposeg) {
												console.error("dio " + part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].condition.object[xxx]].name + " različit broj po segmenatu od " + part.parts[ttmob].name);
												return
											}
											if (part.parts[ttmob].brojseg != part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].condition.object[xxx]].brojseg) {
												console.error("dio " + part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].condition.object[xxx]].name + " različit broj segmenata od " + part.parts[ttmob].name);
												return
											}
											movobj[obcolindex].userData.movingPropertiesData.condition.state[xxx] = part.parts.mobileparam.movingPropertiesData[ttmob].condition.state[xxx];
											for (var bs = 0; bs < part.parts[ttmob].brojseg; bs++) {
												for (var bps = 0; bps < part.parts[ttmob].brojseg; bps++) {
													var nme = parent.name + " " + part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].condition.object[xxx]].name + " " + bs + " " + bps;
													for (var namesearch = 0; namesearch < parent.children.length; namesearch++) {
														if (parent.children[namesearch].name == nme) {
															movobj[obcolindex].userData.movingPropertiesData.condition.object[xxx] = parent.children[namesearch]
														}
													}
												}
											}
										}
									} else {
										if (part.parts.mobileparam.movingPropertiesData[ttmob].condition.object) {
											movobj[obcolindex].userData.movingPropertiesData.condition.object = {};
											movobj[obcolindex].userData.movingPropertiesData.condition.object.clonePrev = part.parts.mobileparam.movingPropertiesData[ttmob].condition.object.clonePrev;
											movobj[obcolindex].userData.movingPropertiesData.condition.object.cloneNext = part.parts.mobileparam.movingPropertiesData[ttmob].condition.object.cloneNext;
											doClones = true
										}
									}
								}
								movobj[obcolindex].userData.isDifferential = part.parts.mobileparam.isDifferential[ttmob];
								movobj[obcolindex].userData.startcondition = part.parts.mobileparam.startcondition[ttmob];
								movobj[obcolindex].userData.state = part.parts.mobileparam.movingPropertiesData[ttmob].defaultState;
								if (part.parts.mobileparam.movingPropertiesData[ttmob].tweenmethod == "TWEEN.Easing.Sinusoidal.InOut") {
									movobj[obcolindex].userData.movingPropertiesData.tweenmethod = TWEEN.Easing.Sinusoidal.InOut
								}
								if (part.parts.mobileparam.movingPropertiesData[ttmob].tandemMain) {
									movobj[obcolindex].userData.movingPropertiesData.tandemMain = part.parts.mobileparam.movingPropertiesData[ttmob].tandemMain
								}
								if (part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith) {
									var tancheck = false;
									for (var tt = 0; tt < part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith.length; tt++) {
										if (part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith[tt] != -1) {
											if (part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith[tt]].brojseg != part.parts[part.parts.mobileparam.movingParts[ttmob]].brojseg) {
												console.error("dio " + part.parts[part.parts.mobileparam.movingParts[ttmob]].name + " različit broj segmenata od " + part.parts[part.parts.mobileparam.movingParts[ttmob].tandemWith[tt]].name);
												break
											}
											if (part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith[tt]].brojposeg < part.parts[part.parts.mobileparam.movingParts[ttmob]].brojposeg) {
												console.error("dio " + part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith[tt]].name) + " manji broj po segmenatu od " + part.parts[part.parts.mobileparam.movingParts[ttmob]].name;
												break
											}
											for (var tbps = 0; tbps < part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith[tt]].brojposeg; tbps++) {
												for (var namesearch = 0; namesearch < parent.children.length; namesearch++) {
													if (parent.children[namesearch].name == parent.name + " " + part.parts[part.parts.mobileparam.movingPropertiesData[ttmob].tandemWith[tt]].name + " " + t + " " + tbps) {
														if (!movobj[obcolindex].userData.tandems) {
															movobj[obcolindex].userData.tandems = []
														}
														movobj[obcolindex].userData.tandems.push(parent.children[namesearch]);
														if (parent.children[namesearch].userData.tandems) {
															for (var t3 = 0; t3 < parent.children[namesearch].userData.tandems.length; t3++) {
																if (parent.children[namesearch].userData.tandems[t3].name == parent.children[nsearch].name) {
																	tancheck = true
																}
															}
															if (!tancheck) {
																parent.children[namesearch].userData.tandems.push(parent.children[nsearch])
															}
														} else {
															parent.children[namesearch].userData.tandems = [];
															parent.children[namesearch].userData.tandems.push(parent.children[nsearch])
														}
													}
												}
											}
										} else {
											if (!parent.userData.tandems) {
												parent.userData.tandems = []
											};
											if (!movobj[obcolindex].userData.tandems) {
												movobj[obcolindex].userData.tandems = []
											};
											parent.userData.tandems.push(movobj[obcolindex]);
											movobj[obcolindex].userData.tandems.push(parent)
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}

function partplace(obj, loc, rot, parent, step, c, env, namech, part, ext) {
	ready++;
	if (!obj) {
		console.warn("greška! parent name=" + parent.name + " child name=" + namech + " seg=" + c + " ext=" + ext)
	}
	var tobj = obj[0].clone();
	tobj.rotation.x = rot.x;
	tobj.rotation.y = rot.y;
	tobj.rotation.z = rot.z;
	tobj.scale = tscale;
	tobj.position.x = (loc.x + step.x * c) * tscale;
	tobj.position.y = (loc.y + step.y * c) * tscale;
	tobj.position.z = (loc.z + step.z * c) * tscale;
	tobj.updateMatrix();
	if (env) {
		tobj.traverse(function (node) {
			if (node.material) {
				if (node.material.materials) {
					for (var t = 0; t < node.material.materials.length; t++) {
						node.material.materials[t].envMap = env;
						//node.material.materials[t].metal = true
					}
				} else {
					node.material.envMap = env;
					//node.material.metal = true
				}
			}
		})
	}
	if (tobj.children) {
		tobj.traverse(function (node) {
			if (node.geometry) {
				node.geometry.computeBoundingBox()
			}
		})
	} else {
		tobj.geometry.computeBoundingBox()
	}
	tobj.name = parent.name + " " + namech;
	if (part.parts.mobile) {
		if (part.parts[ext].mobile) {
			tobj.userData.mobile = true
		}
	}
	parent.add(tobj);
	tobj.updateMatrixWorld()
}

function getExtras(dil, set) {
	for (var t = dil.parts.external; t < dil.parts.broj; t++) {
		var tcolors;
		var geometry = new THREE.BufferGeometry();
		var positions = new Float32Array(dil.parts[t].geometry.length);
		var normals = new Float32Array(dil.parts[t].normals.length);
		for (var cl = 0; cl < dil.parts[t].geometry.length; cl++) {
			positions[cl] = dil.parts[t].geometry[cl];
			normals[cl] = dil.parts[t].normals[cl]
		};
		if (dil.parts[t].colors) {
			tcolors = new Float32Array(dil.parts[t].colors.length);
			for (var cl = 0; cl < dil.parts[t].colors.length; cl++) {
				tcolors[cl] = dil.parts[t].colors[cl]
			}
		} else {
			tcolors = new Float32Array(dil.parts[t].geometry.length);
			for (var cl = 0; cl < dil.parts[t].geometry.length; cl++) {
				tcolors[cl] = 0
			}
		};
		geometry.addAttribute( 'color', new THREE.BufferAttribute( tcolors , 3 ));
		geometry.addAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
		geometry.addAttribute( 'normal', new THREE.BufferAttribute( normals, 3 ) );
		var material = new THREE.MeshPhongMaterial(dil.parts[t].materials);
		var mesh = new THREE.Mesh(geometry, material);
		mesh.castShadow = shadow;
		mesh.receiveShadow = shadow;
		mesh.name = dil.parts[t].name;
		set[t] = mesh;
		if (dil.parts[t].alphaMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				data[0].material.alphaMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].alphaMap, txtmp, [set[t], dil.parts[t].alphaMapRepeat])
		}
		if (dil.parts[t].aoMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				if (data[2] !== undefined) {
					data[0].material.aoMapIntensity = data[2]
				}
				data[0].material.aoMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].aoMap, txtmp, [set[t], dil.parts[t].aoMapRepeat, aoMapIntensity])
		}
		if (dil.parts[t].bumpMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				if (data[2] !== undefined) {
					data[0].material.bumpScale = data[2]
				}
				data[0].material.bumpMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].bumpMap, txtmp, [set[t], dil.parts[t].bumpMapRepeat, dil.parts[t].bumpScale])
		}
		if (dil.parts[t].displacementMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				if (data[2] !== undefined) {
					data[0].material.displacementScale = data[2]
				}
				if (data[3] !== undefined) {
					data[0].material.displacementBias = data[3]
				}
				data[0].material.displacementMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].displacementMap, txtmp, [set[t], dil.parts[t].displacementMapRepeat, displacementScale, displacementBias])
		}
		if (dil.parts[t].emissiveMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				data[0].material.emissiveMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].emissiveMap, txtmp, [set[t], dil.parts[t].emissiveMapRepeat])
		}
		if (dil.parts[t].lightMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				if (data[2] !== undefined) {
					data[0].material.lightMapIntensity = data[2]
				}
				data[0].material.lightMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].lightMap, txtmp, [set[t], dil.parts[t].lightMapRepeat, lightMapIntensity])
		}
		if (dil.parts[t].map) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				data[0].material.map = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].map, txtmp, [set[t], dil.parts[t].mapRepeat])
		}
		if (dil.parts[t].normalMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				if (data[2] !== undefined) {
					data[0].material.normalScale = data[2]
				}
				data[0].material.normalMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].normalMap, txtmp, [set[t], dil.parts[t].normalMapRepeat, dil.parts[t].normalScale])
		}
		if (dil.parts[t].specularMap) {
			var txtmp = function (texture, data) {
				if (data[1]) {
					texture.wrapS = THREE.RepeatWrapping;
					texture.wrapT = THREE.RepeatWrapping
				}
				data[0].material.specularMap = texture;
				data[0].material._needsUpdate = true
			};
			txloader.xload(textures + dil.parts[t].specularMap, txtmp, [set[t], dil.parts[t].specularMapRepeat])
		}
	}
}

function partload(path, file, xx) {
	parts[xx] = 0;
	cnt=0
	prt[xx] = [];
	vrobj[xx] = new XMLHttpRequest();
	vrobj[xx].overrideMimeType("application/json");
	vrobj[xx].open("GET", path + file + ".js", true);
	vrobj[xx].onreadystatechange = function () {
		if (vrobj[xx].readyState == 4 && vrobj[xx].status == 200) {
			dio[xx] = JSON.parse(vrobj[xx].responseText);
			partsGoal[xx] = dio[xx].parts.external;
			if (dio[xx].parts.noClone) {
				var extra = dio[xx].parts.noClone.parts.external
			} else {
				var extra = 0
			}
			partsGoal[xx] = partsGoal[xx] + extra;
			var zzt = 0;
			var pt1 = 0;
			var pt2 = 0;
			for (var r = 0; r < dio[xx].parts.broj; r++) {
				if (dio[xx].parts.clone) {
					if (dio[xx].parts[r].childTo) {
						readytott = readytott + dio[xx].parts[dio[xx].parts[r].childTo].brojseg * dio[xx].parts[dio[xx].parts[r].childTo].brojposeg * dio[xx].parts[r].brojseg * dio[xx].parts[r].brojposeg * (dio[xx].parts.clone + 1)
					} else {
						readytott = readytott + dio[xx].parts[r].brojseg * dio[xx].parts[r].brojposeg * (dio[xx].parts.clone + 1)
					}
				} else {
					if (dio[xx].parts[r].childTo) {
						readytott = readytott + dio[xx].parts[dio[xx].parts[r].childTo].brojseg * dio[xx].parts[dio[xx].parts[r].childTo].brojposeg * dio[xx].parts[r].brojseg * dio[xx].parts[r].brojposeg
					} else {
						readytott = readytott + dio[xx].parts[r].brojseg * dio[xx].parts[r].brojposeg
					}
				}
			}
			textotal += dio[xx].parts.textures;
			firstframe += dio[xx].parts.textures;
			if (dio[xx].parts.noClone) {
				for (var r = 0; r < dio[xx].parts.noClone.parts.broj; r++) {
					if (dio[xx].parts.noClone.parts[r].childTo) {
						readytott = readytott + dio[xx].parts.noClone.parts[dio[xx].parts.noClone.parts[r].childTo].brojseg * dio[xx].parts.noClone.parts[dio[xx].parts.noClone.parts[r].childTo].brojposeg * dio[xx].parts.noClone.parts[r].brojseg * dio[xx].parts.noClone.parts[r].brojposeg
					} else {
						readytott = readytott + dio[xx].parts.noClone.parts[r].brojseg * dio[xx].parts.noClone.parts[r].brojposeg
					}
				}
			}
			for (var zz = 0; zz < partsGoal[xx] - extra; zz++) {
				if (dio[xx].parts[zz].file) {
					if (dio[xx].parts[zz].file.type == "objmt") {
						var obloader = new THREE.OBJMTLLoader();
						var callbackpr = function (object, data) {
							object.children[2].userData.ID = dio[data[0]].parts[data[1]].id;
//							object.children[1].material = object.children[2].material;
//							object.children[2].material = new THREE.MeshFaceMaterial( [new THREE.MeshPhongMaterial({"color":object.children[2].material.color,"emissive":object.children[2].material.emissive,"specular":object.children[2].material.specular,"shininess":object.children[2].material.shininess,"reflectivity":object.children[2].material.reflectivity,"specular":object.children[2].material.specular,"env":textureCube})]);
//							object.children[2].material = new THREE.MeshFaceMaterial([object.children[2].material]);
//							object.children[2] = createScene("", object.children[2].geometry, [object.children[2].material], false, 0, 0, 0, tscale, shd);
							prt[data[0]][dio[data[0]].parts[data[1]].id] = object.children[2];
							parts[data[0]]++;
							if (parts[data[0]] == partsGoal[data[0]]) {
								partloaded(dio, data[0], prt)
							}
						};
						obloader.load(path + dio[xx].parts[zz].file.file + ".obj", path + dio[xx].parts[zz].file.file + ".mtl", callbackpr, [xx, zz])
					} else if (dio[xx].parts[zz].file.type == "objmtl") {cnt++;
						var tloader = new THREE.MTLLoader();
						tloader.setPath(path);
						if (dio[xx].parts[zz].xOrig!==undefined){
							tloader.setCrossOrigin(dio[xx].parts[zz].xOrig)
						}
						tloader.setTexturePath(dio[xx].parts[zz].texturePath||textures);
						var callbackpr = function(obmaterial, data) {
							var tobloader = new THREE.OBJLoader();
							tobloader.setPath(path);
							var callbackpr = function(object, dataa) {
								if (object.children.length==1){
									parts[dataa[0]]++;
									object=object.children[0];object.parent.remove(object);
									if (shadow){
										object.castShadow=true;
										if (shadow==2){
											object.receiveShadow=true
										}
									}
									object.userData.ID = dio[dataa[0]].parts[dataa[1]].id;
									prt[dio[dataa[0]].parts[dataa[1]].id] = object;
									if (parts[dataa[0]] == partsGoal) {
										partloaded(dio, dataa[0], prt)
									}
								}
							}
							obmaterial.preload();
							tobloader.setMaterials(obmaterial);
							tobloader.xload(dio[data[0]].parts[data[1]].file.file + '.obj', callbackpr, data)
						};
							tloader.xload((dio[xx].parts[zz].file.mtlfile||dio[xx].parts[zz].file.file) + '.mtl', callbackpr, [xx,zz])
					} else if (dio[xx].parts[zz].file.type == "DAE") {
							var obloader = new THREE.ColladaLoader();
							var callbackpr = function (object, data) {
								object.scene.traverse(function (node) {
									if (node.geometry && !node.children[0]) {
										node.name = dio[data[0]].parts[data[1]].name;
										node.userData.ID = dio[data[0]].parts[data[1]].id;
										prt[data[0]][dio[data[0]].parts[data[1]].id] = node;
										parts[data[0]]++;
										if (parts[data[0]] == partsGoal[data[0]]) {
											partloaded(dio, data[0], prt)
										}
									}
								})
							};
							obloader.xload(path + dio[xx].parts[zz].file.file + ".dae", callbackpr, [xx, zz])
					} else if (dio[xx].parts[zz].file.type == "JD") {cnt++;
						var obloader = new THREE.JDLoader();
						if (dio[xx].parts[zz].xOrig!==undefined){
							tloader[zz].crossOrigin=dio[xx].parts[zz].xOrig
						}
						obloader.setTexturePath(dio[xx].parts[zz].texturePath||textures);
						dblmat=new THREE.Object3D();
						var callbackDio = function(object, data) {
							for (var tttt=0;tttt<object.objects.length;tttt++){
								dblmat.add(object.createObject(tttt));
								if (shadow){
									dblmat.children[tttt].castShadow=true;
									if (shadow==2){
										dblmat.children[tttt].receiveShadow=true;
									}
								}
								if (dio[data[0]].parts[data[1]].texturePath){
									dblmat.children[tttt].receiveShadow=true;
								}
							}
							dblmat.userData.ID = dio[data[0]].parts[data[1]].id;
							prt[data[0]][dio[data[0]].parts[data[1]].id] = dblmat;
							parts[data[0]]++;
							if (parts[data[0]] == partsGoal[data[0]]) {
								partloaded(dio, data[0], prt)
							}
						};
						obloader.load(path + dio[xx].parts[zz].file.file + ".JD", callbackDio, [xx,zz])
					} else if (dio[xx].parts[zz].file.type == "FBX") {cnt++;
						var obloader = new THREE.FBXLoader();
						if (dio[xx].parts[zz].xOrig!==undefined){
							tloader[zz].crossOrigin=dio[xx].parts[zz].xOrig
						}
//						obloader.setTexturePath(dio[xx].parts[zz].texturePath||textures);
						dblmat=new THREE.Object3D();
						var callbackDio = function(object, data) {
//							for (var tttt=0;tttt<object.objects.length;tttt++){
								dblmat=object;
								data=[0,0];
								if (shadow){
									dblmat.castShadow=true;
									if (shadow==2){
										dblmat.receiveShadow=true;
									}
								}
								if (dio[data[0]].parts[data[1]].texturePath){
									dblmat.receiveShadow=true;
								}
//							}
							dblmat.userData.ID = dio[data[0]].parts[data[1]].id;
							prt[data[0]][dio[data[0]].parts[data[1]].id] = dblmat;
							parts[data[0]]++;
							if (parts[data[0]] == partsGoal[data[0]]) {
								partloaded(dio, data[0], prt)
							}
						};
						obloader.load(path + dio[xx].parts[zz].file.file + ".fbx", callbackDio)
					} else if (dio[xx].parts[zz].file.type == "JSON") {
								var callbackDio = function (geometry, materials, data) {
									dblmat = createScene("", geometry, materials, false, 0, 0, 0, tscale, shd);
									dblmat.userData.ID = dio[data[0]].parts[data[1]].id;
									prt[data[0]][dio[data[0]].parts[data[1]].id] = dblmat;
									parts[data[0]]++;
									if (parts[data[0]] == partsGoal[data[0]]) {
										partloaded(dio, data[0], prt)
									}
								};
								loader.xload(path + dio[xx].parts[zz].file.file + ".js", callbackDio, [xx, zz])
							}
				} else {
					var callbackDio = function (geometry, materials, data) {
						dblmat = createScene("", geometry, materials, false, 0, 0, 0, tscale, shd);
						dblmat.userData.ID = dio[data[0]].parts[data[1]].id;
						prt[data[0]][dio[data[0]].parts[data[1]].id] = dblmat;
						parts[data[0]]++;
						if (parts[data[0]] == partsGoal[data[0]]) {
							partloaded(dio, data[0], prt)
						}
					};
					loader.xload(path + file + zz + ".js", callbackDio, [xx, zz])
				}
			}
			if (dio[xx].parts.noClone) {
				for (var t = 0; t < dio[xx].parts.noClone.parts.broj; t++) {
					if (dio[xx].parts.noClone.parts[t].file) {
						if (dio[xx].parts.noClone.parts[t].file.type == "objmt") {
							var obloader = new THREE.OBJMTLLoader();
							var callbackpr = function (object, data) {
								object.children[1].userData.ID = dio[data[0]].parts.noClone.parts[data[1]].id;
								//object.children[1].material = object.children[2].material;
//								object.children[2].material = new THREE.MeshPhongMaterial({"color":object.children[2].material.color,"emissive":object.children[2].material.emissive,"specular":object.children[2].material.specular,"shininess":object.children[2].material.shininess,"reflectivity":object.children[2].material.reflectivity});
								prt[data[0]][dio[data[0]].parts.noClone.parts[data[1]].id] = object.children[2];
								parts[data[0]]++;
								if (parts[data[0]] == partsGoal[data[0]]) {
									partloaded(dio, data[0], prt)
								}
							};
							obloader.load(path + dio[xx].parts.noClone.parts[t].file.file + ".obj", path + dio[xx].parts.noClone.parts[t].file.mtlfile + ".mtl", callbackpr, [xx, t])
					} else if (dio[xx].parts.noClone.parts[t].file.type == "objmtl") {cnt++;
						var tloader = new THREE.MTLLoader();
						tloader.setPath(path);
						if (dio[xx].parts.noClone.parts[t].xOrig!==undefined){
							tloader.setCrossOrigin(dio[xx].parts.noClone.parts[t].xOrig)
						}
						tloader.setTexturePath(dio[xx].parts.noClone.parts[t].texturePath||textures);
						var callbackpr = function(obmaterial, data) {
							var tobloader = new THREE.OBJLoader();
							tobloader.setPath(path);
							var callbackpr = function(object, dataa) {
								if (object.children.length==1){
									parts[dataa[0]]++;
									object=object.children[0];object.parent.remove(object);
									if (shadow){
										object.castShadow=true;
										if (shadow==2){
											object.receiveShadow=true
										}
									}
									object.userData.ID = dio[dataa[0]].parts.noClone.parts[dataa[1]].id;
									prt[dio[dataa[0]].parts.noClone.parts[dataa[1]].id] = object;
									if (parts[dataa[0]] == partsGoal) {
										partloaded(dio, dataa[0], prt)
									}
								}
							}
							obmaterial.preload();
							tobloader.setMaterials(obmaterial);
							tobloader.xload(dio[data[0]].parts.noClone.parts[data[1]].file.file + '.obj', callbackpr, data)
						};
							tloader.xload((dio[xx].parts.noClone.parts[t].file.mtlfile||dio[xx].parts.noClone.parts[t].file.file) + '.mtl', callbackpr, [xx,t])
						} else if (dio[xx].parts.noClone.parts[t].file.type == "DAE") {
								var obloader = new THREE.ColladaLoader();
								var callbackpr = function (object, data) {
									object.scene.traverse(function (node) {
										if (node.geometry && !node.children[0]) {
											node.name = dio[data[0]].parts.noClone.parts[data[1]].name;
											node.userData.ID = dio[data[0]].parts.noClone.parts[data[1]].id;
											prt[data[0]][dio[data[0]].parts.noClone.parts[data[1]].id] = node;
											parts[data[0]]++;
											if (parts[data[0]] == partsGoal[data[0]]) {
												partloaded(dio, data[0], prt)
											}
										}
									})
								};
								obloader.xload(path + dio[xx].parts.noClone.parts[t].file.file + ".dae", callbackpr, [xx, t])
							} else if (dio[xx].parts.noClone.parts[t].file.type == "JSON") {
									var callbackDio = function (geometry, materials, data) {
										dblmat = createScene("", geometry, materials, false, 0, 0, 0, tscale, shd);
										dblmat.userData.ID = dio[data[0]].parts.noClone.parts[data[1]].id;
										prt[data[0]][dio[data[0]].parts.noClone.parts[data[1]].id] = dblmat;
										parts[data[0]]++;
										if (parts[data[0]] == partsGoal[data[0]]) {
											partloaded(dio, data[0], prt)
										}
									};
									loader.xload(path + dio[xx].parts.noClone.parts[t].file.file + ".js", callbackDio, [xx, t])
								}
					} else {
						var callbackDioNoClone = function (geometry, materials, data) {
							dblmat = createScene("", geometry, materials, false, 0, 0, 0, tscale, shd);
							dblmat.userData.ID = dio[data[0]].parts.noClone.parts[data[1]].id;
							prt[data[0]][dio[data[0]].parts.noClone.parts[data[1]].id] = dblmat;
							parts[data[0]]++;
							if (parts[data[0]] == partsGoal[data[0]]) {
								partloaded(dio, data[0], prt)
							}
						};
						loader.xload(path + file + (dio[xx].parts.broj + t) + ".js", callbackDioNoClone, [xx, dio[xx].parts.broj + t])
					}
				}
			}
		}
	};
	vrobj[xx].send(null)
}

function partloaded(dio, xx, prt) {
	if (dio[xx].parts.broj > dio[xx].parts.external) {
		getExtras(dio[xx], prt[xx])
	}
	compositeObject[xx] = new THREE.Object3D();
	if (dio[xx].parts.clone) {
		totclones[totclones.length] = [];
		var possx = dio[xx].parts.pos.step.pos.x * dio[xx].parts.clone / 2 * (-1);
		var possy = dio[xx].parts.pos.step.pos.y * dio[xx].parts.clone / 2 * (-1);
		var possz = dio[xx].parts.pos.step.pos.z * dio[xx].parts.clone / 2 * (-1);
		if (dio[xx].parts.noClone) {
			compositeObject[xx].name = dio[xx].parts.name;// var offset= dio[xx].parts.broj;var total= dio[xx].parts.noClone.parts.broj;
//			for (var t = 0; t < dio[xx].parts.noClone.parts.broj; t++) {
				slagalica(dio[xx].parts.noClone, xx, compositeObject[xx], prt, dio[xx].parts.broj)
//			}
		}
		for (var t = 0; t < dio[xx].parts.clone + 1; t++) {
			var tmocomposite = new THREE.Object3D();
			tmocomposite.userData.ID = xx + t;
			tmocomposite.name = dio[xx].parts.name + " clone " + t;
			slagalica(dio[xx], xx, tmocomposite, prt);
			totclones[totclones.length - 1].push(tmocomposite);
			if (dio[xx].parts.pos.step.pos.x){tmocomposite.position.x = tmocomposite.children[0].position.x + dio[xx].parts.pos.step.pos.x*t}
			if (dio[xx].parts.pos.step.pos.y){tmocomposite.position.y = tmocomposite.children[0].position.y + dio[xx].parts.pos.step.pos.y*t}
			if (dio[xx].parts.pos.step.pos.z){tmocomposite.position.z = tmocomposite.children[0].position.z + dio[xx].parts.pos.step.pos.z*t}
			tmocomposite.rotation.x = t * dio[xx].parts.pos.step.rot.x;
			tmocomposite.rotation.y = t * dio[xx].parts.pos.step.rot.y;
			tmocomposite.rotation.z = t * dio[xx].parts.pos.step.rot.z;
			tmocomposite.scale.x = 1 + t * dio[xx].parts.pos.step.siz.x;
			tmocomposite.scale.y = 1 + t * dio[xx].parts.pos.step.siz.y;
			tmocomposite.scale.z = 1 + t * dio[xx].parts.pos.step.siz.z;
			compositeObject[xx].add(tmocomposite)
		}
	} else {
		compositeObject[xx].name = dio[xx].parts.name;
		slagalica(dio[xx], xx, compositeObject[xx], prt)
	}
	compositeObject[xx].castShadow = shadow;
	compositeObject[xx].receiveShadow = shadow;
	compositeObject[xx].name = dio[xx].parts.name;
	compositeObject[xx].scale.x = dio[xx].parts.pos.siz.x;
	compositeObject[xx].scale.y = dio[xx].parts.pos.siz.y;
	compositeObject[xx].scale.z = dio[xx].parts.pos.siz.z;
	compositeObject[xx].userData.cam = dio[xx].parts.cpos;
	compositeObject[xx].userData.ID = xx;
	compositeObject[xx].userData.BBox = new THREE.Box3().setFromObject(compositeObject[xx]);
	compositeObject[xx].rotation.x = dio[xx].parts.pos.rot.x;
	compositeObject[xx].rotation.y = dio[xx].parts.pos.rot.y;
	compositeObject[xx].rotation.z = dio[xx].parts.pos.rot.z;
	camera1.position.x = compositeObject[xx].userData.cam.loc.x;
	camera1.position.y = compositeObject[xx].userData.cam.loc.y;
	camera1.position.z = compositeObject[xx].userData.cam.loc.z;
	startTarget = new THREE.Box3().setFromObject(compositeObject[xx]).getCenter();
	camera1.updateMatrixWorld();
	camera1.lookAt(startTarget);
	camera1.updateMatrixWorld();
//	startTarget = new THREE.Vector3();
	controls = new THREE.OrbitControls(camera1, renderer.domElement);
	controls.target=startTarget;
	controls.minPolarAngle = Math.PI / 3;
	controls.maxPolarAngle = Math.PI / 2;
	controls.minDistance = 60;
	controls.maxDistance = 500;
	controls.enabled = true;
	controls.update();
	controls.enablePan=false;
	scene.add(compositeObject[xx]);
	if (xx == totob - 1) {
		readytot = readytott
	}
}

function lightsMake(sc, pod) {
	if (pod) {
		var meshp = new THREE.Mesh(new THREE.PlaneBufferGeometry(600, 600), new THREE.MeshPhongMaterial({color: 0x808080}));
		meshp.rotation.x = -(90 * Math.PI / 180);
		meshp.receiveShadow = shadow;
		meshp.name = "Pod";
		sc.add(meshp);
		var txtre = function (texture, data) {
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(60, 60);
			data.material.map = texture;
			data.material._needsUpdate = true;
			firstframe++;
			textotal++
		};
		var txtres = function (texture, data) {
			texture.wrapS = THREE.RepeatWrapping;
			texture.wrapT = THREE.RepeatWrapping;
			texture.repeat.set(60, 60);
			data.material.bumpMap = texture;
			data.material.specularMap = texture;
			data.material._needsUpdate = true;
			firstframe++;
			textotal++
		};
		txloader.xload("textures/Pod.jpg", txtre, meshp);
		txloader.xload("textures/PodSpec.jpg", txtres, meshp)
	};
	var DirectionalLight = new THREE.DirectionalLight(0xffffff, 1);
	DirectionalLight.position.set(0.75, 1, 1);
	DirectionalLight.castShadow = shadow;
	DirectionalLight.shadow.mapSize.width = 2048;
	DirectionalLight.shadow.mapSize.height= 2048;
	DirectionalLight.shadow.camera.near = 1;
	DirectionalLight.shadow.camera.far = 500;
	DirectionalLight.shadow.camera.fov = 20;
	DirectionalLight.shadow.camera.far = 3500;
	DirectionalLight.name = "Svitlo Dir";
	sc.add(DirectionalLight);
	var DirectionalLight2 = new THREE.DirectionalLight(0xffffff, 1);
	DirectionalLight2.position.set(-0.75, 1, -1);
	DirectionalLight2.castShadow = shadow;
	DirectionalLight2.shadow.mapSize.width = 2048;
	DirectionalLight2.shadow.mapSize.height= 2048;
	DirectionalLight2.shadow.camera.near = 1;
	DirectionalLight2.shadow.camera.far = 500;
	DirectionalLight2.shadow.camera.fov = 20;
	DirectionalLight2.shadow.camera.far = 3500;
	DirectionalLight2.name = "Svitlo Dir2";
	sc.add(DirectionalLight2)
}

function findPos(obj, coord) {
	var curleft = 0;
	var curtop = 0;
	if (obj.offsetParent) {
		do {
			curleft += obj.offsetLeft;
			curtop += obj.offsetTop
		} while (obj = obj.offsetParent);
		if (coord) {
			coord.x = curleft;
			coord.y = curtop
		} else {
			offsetX = curleft;
			offsetY = curtop
		}
	}
}

function buttondown(event) {
	var bound = event.target.getBoundingClientRect();
	var tmouse = {};
	tmouse.x = ((event.clientX - bound.left) / event.target.clientWidth) * 2 - 1;
	tmouse.y = -((event.clientY - bound.top) / event.target.clientHeight) * 2 + 1;
	raylogo.setFromCamera(tmouse, logocam);
	var collisions = raylogo.intersectObjects(logoscn.children, true);
	if (event.button == 0 && collisions.length > 0) {
		window.open("https://3dwebvision.com/", "_parent")
	}
}

function resizer() {
	firstframe++;
	findPos(renderer.domElement);
	logopos();
	SCREEN_WIDTH = window.innerWidth;
	SCREEN_HEIGHT = window.innerHeight;
	logoelemen.style.width = window.innerWidth / 100 * lsize + "px";
	logoelemen.style.height = window.innerWidth / 100 * lsize + "px";
	logocam.updateProjectionMatrix();
	logoren.setSize(window.innerWidth / 100 * lsize, window.innerWidth / 100 * lsize);
	camera1.aspect = SCREEN_WIDTH / SCREEN_HEIGHT;
	camera1.updateProjectionMatrix();
	renderer.setSize(SCREEN_WIDTH, SCREEN_HEIGHT)
}

function logopos() {
	logoelemen.style.top = "1%";
	logoelemen.style.left = "1%"
}

function materialManager(arr, rr) {
	var mats1 = [];
	var found = false;
	arr.traverse(function (node) {
		var tname;
		if (node.material) {
			if (node.material.name !== undefined && node.material.morphTargets === false) {
				tname = node.material.name;
				for (var t = 0; t < mats1.length; t++) {
					if (mats1.name === tname) {
						found = true
					}
				};
				if (!found) {
					mats1.push(node.material)
				} else {
					found = false
				}
			} else {
				if (node.material.materials) {
					for (var t = 0; t < node.material.materials.length; t++) {
						if (node.material.materials[t].morphTargets === false) {
							tname = node.material.materials[t].name;
							for (var ttt = 0; ttt < mats1.length; ttt++) {
								if (mats1[ttt].name === tname) {
									found = true
								}
							};
							if (!found) {
								mats1.push(node.material.materials[t])
							} else {
								found = false
							}
						}
					}
				}
			}
		}
	});
	totalMaterials[rr] = mats1;
	arr.traverse(function (node) {
		var tname;
		if (node.material) {
			if (node.material.name !== undefined && node.material.morphTargets === false) {
				tname = node.material.name;
				for (var t = 0; t < mats1.length; t++) {
					if (mats1[t].name === tname) {
						node.material = mats1[t]
					}
				}
			} else {
				if (node.material.materials) {
					for (var t = 0; t < node.material.materials.length; t++) {
						tname = node.material.materials[t].name;
						for (var ttt = 0; ttt < mats1.length; ttt++) {
							if (mats1[ttt].name === tname && node.material.materials[t].morphTargets === false) {
								node.material.materials[t] = mats1[ttt]
							}
						}
					}
				}
			}
		}
	})
}

/*THREE.Matrix4.prototype.premultiply=function(m){

		return this.multiplyMatrices( m, this );
}

THREE.TextureLoader.prototype.xload = function (url, onLoad, userData, onProgress, onError) {
	var texture = new THREE.Texture();
	var loader = new THREE.ImageLoader(this.manager);
	loader.setCrossOrigin(this.crossOrigin);
	loader.load(url, function (image) {
		texture.image = image;
		texture.needsUpdate = true;
		if (onLoad !== undefined) {
			onLoad(texture, userData)
		}
	}, onProgress, onError);
	return texture, userData
};
THREE.JSONLoader.prototype.xload = function (url, onLoad, userData, onProgress, onError) {
	var scope = this;
	var texturePath = this.texturePath && (typeof this.texturePath === "string") ? this.texturePath : THREE.Loader.prototype.extractUrlBase(url);
	var loader = new THREE.XHRLoader(this.manager);
	loader.setCrossOrigin(this.crossOrigin);
	loader.setWithCredentials(this.withCredentials);
	loader.load(url, function (text) {
		var json = JSON.parse(text);
		var metadata = json.metadata;
		if (metadata !== undefined) {
			if ( metadata.type === 'object' ) {
				console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.ObjectLoader instead.' );
				return
			}
			if ( metadata.type === 'scene' ) {
				console.error( 'THREE.JSONLoader: ' + url + ' should be loaded with THREE.SceneLoader instead.' );
				return
			}
		}
		var object = scope.parse(json, texturePath);
		onLoad(object.geometry, object.materials, userData)
	})
};
THREE.Mesh.prototype.raycast = (function () {
	var inverseMatrix = new THREE.Matrix4();
	var ray = new THREE.Ray();
	var sphere = new THREE.Sphere();
	var vA = new THREE.Vector3();
	var vB = new THREE.Vector3();
	var vC = new THREE.Vector3();
	var tempA = new THREE.Vector3();
	var tempB = new THREE.Vector3();
	var tempC = new THREE.Vector3();
	var uvA = new THREE.Vector2();
	var uvB = new THREE.Vector2();
	var uvC = new THREE.Vector2();
	var barycoord = new THREE.Vector3();
	var intersectionPoint = new THREE.Vector3();
	var intersectionPointWorld = new THREE.Vector3();
	function uvIntersection(point, p1, p2, p3, uv1, uv2, uv3) {
		THREE.Triangle.barycoordFromPoint(point, p1, p2, p3, barycoord);
		uv1.multiplyScalar(barycoord.x);
		uv2.multiplyScalar(barycoord.y);
		uv3.multiplyScalar(barycoord.z);
		uv1.add(uv2).add(uv3);
		return uv1.clone()
	}
	function checkIntersection(object, raycaster, ray, pA, pB, pC, point) {
		var intersect;
		if (object.material.materials !== undefined) {
			var material = object.material.materials[0]
		} else {
			var material = object.material
		};
		if (material.side === THREE.BackSide) {
			intersect = ray.intersectTriangle(pC, pB, pA, true, point)
		} else {
			intersect = ray.intersectTriangle(pA, pB, pC, material.side !== THREE.DoubleSide, point)
		}
		if (intersect === null) return null;
		intersectionPointWorld.copy(point);
		intersectionPointWorld.applyMatrix4(object.matrixWorld);
		var distance = raycaster.ray.origin.distanceTo(intersectionPointWorld);
		if (distance < raycaster.near || distance > raycaster.far) return null;
		return {
			distance: distance,
			point: intersectionPointWorld.clone(),
			object: object
		}
	}
	function checkBufferGeometryIntersection(object, raycaster, ray, positions, uvs, a, b, c) {
		vA.fromArray(positions, a * 3);
		vB.fromArray(positions, b * 3);
		vC.fromArray(positions, c * 3);
		var intersection = checkIntersection(object, raycaster, ray, vA, vB, vC, intersectionPoint);
		if (intersection) {
			if (uvs) {
				uvA.fromArray(uvs, a * 2);
				uvB.fromArray(uvs, b * 2);
				uvC.fromArray(uvs, c * 2);
				intersection.uv = uvIntersection(intersectionPoint, vA, vB, vC, uvA, uvB, uvC)
			}
			intersection.face = new THREE.Face3(a, b, c, THREE.Triangle.normal(vA, vB, vC));
			intersection.faceIndex = a
		}
		return intersection
	}
	return function raycast(raycaster, intersects) {
		var geometry = this.geometry;
		var material = this.material;
		if (material === undefined) return;
		if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
		var matrixWorld = this.matrixWorld;
		sphere.copy(geometry.boundingSphere);
		sphere.applyMatrix4(matrixWorld);
		if (raycaster.ray.isIntersectionSphere(sphere) === false) return;
		inverseMatrix.getInverse(matrixWorld);
		ray.copy(raycaster.ray).applyMatrix4(inverseMatrix);
		if (geometry.boundingBox !== null) {
			if (ray.isIntersectionBox(geometry.boundingBox) === false) return
		}
		var uvs, intersection;
		if (geometry instanceof THREE.BufferGeometry) {
			var a, b, c;
			var index = geometry.index;
			var attributes = geometry.attributes;
			var positions = attributes.position.array;
			if (attributes.uv !== undefined) {
				uvs = attributes.uv.array
			}
			if (index !== null) {
				var indices = index.array;
				for (var i = 0, l = indices.length; i < l; i += 3) {
					a = indices[i];
					b = indices[i + 1];
					c = indices[i + 2];
					intersection = checkBufferGeometryIntersection(this, raycaster, ray, positions, uvs, a, b, c);
					if (intersection) {
						intersection.faceIndex = Math.floor( i / 3 ); // triangle number in indices buffer semantics
						intersects.push(intersection)
					}
				}
			} else {
				for (var i = 0, l = positions.length; i < l; i += 9) {
					a = i / 3;
					b = a + 1;
					c = a + 2;
					intersection = checkBufferGeometryIntersection(this, raycaster, ray, positions, uvs, a, b, c);
					if (intersection) {
						intersection.index = a;
						intersects.push(intersection)
					}
				}
			}
		} else if (geometry instanceof THREE.Geometry) {
				var fvA, fvB, fvC;
				var isFaceMaterial = material instanceof THREE.MeshFaceMaterial;
				var materials = isFaceMaterial === true ? material.materials : null;
				var vertices = geometry.vertices;
				var faces = geometry.faces;
				var faceVertexUvs = geometry.faceVertexUvs[0];
				if (faceVertexUvs.length > 0) uvs = faceVertexUvs;
				for (var f = 0, fl = faces.length; f < fl; f++) {
					var face = faces[f];
					var faceMaterial = isFaceMaterial === true ? materials[face.materialIndex] : material;
					if (faceMaterial === undefined) continue;
					fvA = vertices[face.a];
					fvB = vertices[face.b];
					fvC = vertices[face.c];
					if (faceMaterial.morphTargets === true) {
						var morphTargets = geometry.morphTargets;
						var morphInfluences = this.morphTargetInfluences;
						vA.set(0, 0, 0);
						vB.set(0, 0, 0);
						vC.set(0, 0, 0);
						for (var t = 0, tl = morphTargets.length; t < tl; t++) {
							var influence = morphInfluences[t];
							if (influence === 0) continue;
							var targets = morphTargets[t].vertices;
							vA.addScaledVector(tempA.subVectors(targets[face.a], fvA), influence);
							vB.addScaledVector(tempB.subVectors(targets[face.b], fvB), influence);
							vC.addScaledVector(tempC.subVectors(targets[face.c], fvC), influence)
						}
						vA.add(fvA);
						vB.add(fvB);
						vC.add(fvC);
						fvA = vA;
						fvB = vB;
						fvC = vC
					}
					intersection = checkIntersection(this, raycaster, ray, fvA, fvB, fvC, intersectionPoint);
					if (intersection) {
						if (uvs) {
							var uvs_f = uvs[f];
							uvA.copy(uvs_f[0]);
							uvB.copy(uvs_f[1]);
							uvC.copy(uvs_f[2]);
							intersection.uv = uvIntersection(intersectionPoint, fvA, fvB, fvC, uvA, uvB, uvC)
						}
						intersection.face = face;
						intersection.faceIndex = f;
						intersects.push(intersection)
					}
				}
			}
		}
}())

*/